<template>
    <div class="mark" ></div>
    <div style="position:fixed;left:50%;z-index:501;top:50%;transform:translate(-50%,-50%);width:300px;background:#fff;border-radius: 10px;padding:20px 0;">

    <van-form @submit="onSubmit">
        <van-cell-group inset>
        <van-field
            v-model="state.inputphone"
            name="phone"
            label-width="50"
            label="手机号"
            placeholder="请输入您的会员手机号"
            :rules="[{ required: true, message: '请填写手机号' }]"
        />
        
        </van-cell-group>
        <div style="margin: 16px;">
        <van-button round block :loading="loading" type="primary" native-type="submit" loading-text="加载中...">
            提交
        </van-button>
        </div>
    </van-form>

    </div>
  </template>
  
<script>
    import { reactive,ref } from 'vue';
    import { Cell,Toast, CellGroup,Button,Form,Field } from 'vant';
    import ajax from '@/assets/public.js'

  export default {
    name: 'LogIn',
    components: {
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Toast.name]: Toast,
        [Form.name]: Form,
        [Field.name]: Field,
        [Button.name]: Button
    },
    props: {
      msg: String
    },
    emits:['change'],
    setup(props,context){
        const state=reactive({
            path:'',
            phone:'-1',
            header:ajax.path+'images/no_header.png',
            bi:0,
            card_count:0,
            levelname:'',
        })

        function onSubmit(v){
            if(loading.value==false){
                loading.value=true;
                ajax.req({
                url: 'myinfo/',
                data: {
                    'do': 'update',
                    'phone':v.phone
                },
                }).then(res => {
                loading.value=false;
                if(res.error>0){
                    Toast({
                    message: res.msg,
                    position: 'top',
                    });
                    context.emit('change',res.msg)
                }else{
                    if(res.data){
                        localStorage.setItem('pusern',res.data);
                        window.location.reload();
                    }
                    context.emit('change')
                }
                
                });
            }
        }


        const loading=ref(false);

        return {
            state,
            ajax,
            loading,
            onSubmit
        }
    }
  }
</script>

  